import React, { memo, useMemo } from 'react';
import { Icon } from 'antd';
import { limitCharacterLength } from '~/utils/formatters';
import { necessity } from '../../../constants';
import {
  formatCurrency,
  formatDate,
  hasSource,
  hasValue,
  hasCompanyType,
  hasNecessity,
  hasRate,
} from '../utils';
import { LeadRating } from './LeadRating';
import {
  CalendarIcon,
  Date,
  DateContainer,
  LeadInfo,
  LeadName,
  Value,
  SourceTag,
  CompanyTypeAndNecessityContainer,
  CompanyTypeTag,
  NecessityTag,
  FormIcon,
} from '../styles';

export const LeadInfoSection = memo(({ item, isFromForm }) => {
  const formattedDate = useMemo(() => formatDate(item.created_at), [item.created_at]);
  const limitedName = useMemo(() => limitCharacterLength(item.name, 25), [item.name]);
  
  return (
    <LeadInfo>
      <DateContainer>
        <CalendarIcon />
        <Date>{formattedDate}</Date>
      </DateContainer>
      
      <LeadName>
        <Icon type="user" />
        {limitedName}
        {isFromForm && <FormIcon />}
      </LeadName>
      
      {(hasValue(item) || hasCompanyType(item) || hasNecessity(item) || hasRate(item)) && (
        <CompanyTypeAndNecessityContainer>
          {hasValue(item) && (
            <Value>{formatCurrency(item.honorary)}</Value>
          )}
          <LeadRating rate={item.rate} description={item.description} />
          {hasCompanyType(item) && (
            <CompanyTypeTag color="blue">
              <Icon type="tag" /> {item.company_type}
            </CompanyTypeTag>
          )}
          {hasNecessity(item) && necessity[item.necessity] && (
            <NecessityTag color={necessity[item.necessity].color}>
              <Icon type="question-circle" />{" "}
              {necessity[item.necessity].name}
            </NecessityTag>
          )}
        </CompanyTypeAndNecessityContainer>
      )}
    </LeadInfo>
  );
});

LeadInfoSection.displayName = 'LeadInfoSection';